// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallSharp24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M9 4.5C9.41421 4.5 9.75 4.83579 9.75 5.25L8.75 19.25C8.75 19.6642 8.41421 20 8 20C7.58579 20 7.25 19.6642 7.25 19.25L8.25 5.25C8.25 4.83579 8.58579 4.5 9 4.5ZM16 4.5C16.4142 4.5 16.75 4.83579 16.75 5.25L15.75 19.25C15.75 19.6642 15.4142 20 15 20C14.5858 20 14.25 19.6642 14.25 19.25L15.25 5.25C15.25 4.83579 15.5858 4.5 16 4.5Z" />
				<path d="M19.75 8.75C19.75 9.16421 19.4142 9.5 19 9.5L5 9.5C4.58579 9.5 4.25 9.16421 4.25 8.75C4.25 8.33579 4.58579 8 5 8L19 8C19.4142 8 19.75 8.33579 19.75 8.75ZM19.75 15.75C19.75 16.1642 19.4142 16.5 19 16.5L5 16.5C4.58579 16.5 4.25 16.1642 4.25 15.75C4.25 15.3358 4.58579 15 5 15L19 15C19.4142 15 19.75 15.3358 19.75 15.75Z" />
			</Svg>
		);
	}
);
SvgCallSharp24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallSharp24;
